import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import {PointCloudService} from "../services/point-cloud.service";
import {PointCloud} from "../models/point-cloud";

export const pointCloudResolver: ResolveFn<PointCloud> = (route, state) => {
  const projectId = route.paramMap.get('pointCloud');
  return inject(PointCloudService).detail(projectId!);
};
